import { InputSelect, InputSelectProps } from "components/Atomos/Form/Elements/InputSelect"
import { useEffect } from "react"
import { FieldValues } from "react-hook-form"
import { useAppDispatch, useTypedSelector } from "store/hooks"
import { getComplaintTypesRequest } from "store/modules/complaints/actions/getComplaintTypes"

type ComplaintTypeSelectProps<T extends FieldValues> = Omit<InputSelectProps<T>, 'option'> & {

}

const ComplaintTypeSelect = <T extends FieldValues>({
    ...rest
}: ComplaintTypeSelectProps<T>) => {
    const {
        successPayload,
        isRequesting
    } = useTypedSelector(x => x.complaints.getComplaintTypes);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (successPayload.length <= 0) {
            dispatch(getComplaintTypesRequest({}));
        }
    }, [dispatch]);

    return (
        <InputSelect
            {...rest}
            isLoading={isRequesting}
            option={successPayload.map(item => ({
                value: item.id.toString(),
                label: item.tipoManifestacao,
            }))}
        />
    )
}
export default ComplaintTypeSelect